import { MIN_COLUMN_WIDTH, SWIMLANE_GUTTER_WIDTH } from '@/roadmaps/constants/roadmaps.constants';

export function calculateColumnWidth ({ columnCount, columnBodyWidth }) {
    const gutterWidth = SWIMLANE_GUTTER_WIDTH / 2;

    // Number of columns we could fit in the space,
    // ensuring it's at least one if the width is less than MIN_COLUMN_WIDTH.
    const theoreticalMaxColumns = Math.max(1, Math.floor((columnBodyWidth - gutterWidth) / MIN_COLUMN_WIDTH));

    // Make sure we don't calculate for more columns in the roadmap
    const clampedColumnCount = Math.min(columnCount, theoreticalMaxColumns);

    // There are is always 1 less gutter than there are columns
    const gutterCount = clampedColumnCount - 1;

    const availableSpaceForColumns = columnBodyWidth - gutterCount * gutterWidth;

    return Math.floor(availableSpaceForColumns / clampedColumnCount);
}
